<template>
  <input :class="[inputClass, {['error-label']: errorMessage}]"
         :id="inputId"
         :name="inputId"
         :placeholder="placeholder"
         type="text"
         v-model="inputValue"
         @blur="onBlurInput"
         @change="onChangeInput" />
</template>


<script>
  export default {
    props: {
      inputClass: String,
      inputId: [Number, String],
      textValue: [Number, String],
      placeholder: String,
      useCustomValidation: Boolean,
    },

    name: 'TextInput',

    data() {
      return {
        errorMessage: null,
        inputValue: null,
      }
    },

    methods: {
      onBlurInput() {
        this.$emit('setInteractions', this.inputId)
      },

      onChangeInput(event) {
        this.textValidation(event.currentTarget)
      },

      textValidation($target) {
        if (this.useCustomValidation) {
          this.$emit('customValidation', $target)
        } else {
          this.validateTextInput($target)
        }
      },

      validateTextInput($target) {
        let value = $target.value.trim()

        if (value) {
          if (this.textValue !== value) { this.$emit('saveInput', value) }
          this.errorMessage = null
        } else {
          this.errorMessage = 'field cannot be empty'
        }
      }
    },

    created() {
      if (this.textValue) {
        this.inputValue = this.textValue
      }
    },

    watch: {
      errorMessage: function() {
        this.$emit('setErrorText', this.errorMessage)
      },

      textValue: function() {
        this.inputValue = this.textValue
      }
    }
  }
</script>
